
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './../../../authConfig';
import ButtonLogin from '../Button-Login/Button-Login';
import { callMsGraph } from '../../../graph';
import React, { FC, useState } from 'react';

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
    
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);
    const handleLogin = (loginType: string) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                console.log(e);
                // instance
                // .acquireTokenSilent({
                //     ...loginRequest,
                   
                //     account: accounts[0],
                // })
                // .then((response) => {
                  
                //     console.log("Este es el token:",response);
                //     callMsGraph(response.idToken).then((response) => setGraphData(response));
                // });
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
                sessionStorage.clear();
            });
        }
    }
    return (
         <ButtonLogin onClick={() => handleLogin("popup")} text={"Login"}/>
    )
}



export default SignInButton;
